import styled from 'styled-components';
import { Card } from 'antd';

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;

  @media (max-width: 480px) {
    padding: 16px 12px;
  }
`;

export const BrandHeader = styled.div`
  text-align: center;
  margin-bottom: 24px;
  padding: 16px 0;
`;

export const FormCard = styled(Card)`
  width: 100%;
  max-width: 560px;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);

  .ant-card-body {
    padding: 24px;

    @media (max-width: 480px) {
      padding: 16px;
    }
  }

  .ant-form-item {
    margin-bottom: 16px;
  }

  .ant-form-item-label > label {
    font-weight: 500;
    font-size: 14px;
    color: #333;
  }
`;

export const SectionTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #e74c3c;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #ffecd2;
`;
